import { aggregationServiceApi } from '@/shared/api/aggregation-service.api';
import { Pagination } from '@/shared/lib/interfaces/pagination.interface';

import { transformRealTimeDataResponse } from '../model/helpers/transform-alarms-response.helper';
import { GetYachtAlarmsVariables, YachtAlarm, YachtAlarmResponse } from '../model/types/alarms.interface';

const alarmsApi = aggregationServiceApi.injectEndpoints({
	endpoints: (build) => ({
		getYachtAlarms: build.query<Pagination<YachtAlarm>, GetYachtAlarmsVariables>({
			query: ({ yachtId, page = 1, size = 50, search, showActiveOnly = true }) => ({
				method: 'GET',
				url: `alarms/${yachtId}`,
				params: { page, size, search, show_active_only: showActiveOnly },
			}),
			transformResponse: (response: Pagination<YachtAlarmResponse>, _, { timezone }): Pagination<YachtAlarm> =>
				transformRealTimeDataResponse(response, timezone),
		}),
	}),
});

export const { useGetYachtAlarmsQuery } = alarmsApi;
